import React from 'react'
import { Image } from '../Image'
import { TestimonialDetails } from '../TestimonialDetails'
import { IProps } from './index'
import { mq } from '../../utils'

export class TestimonialMiniCard extends React.PureComponent<IProps> {
  render() {
    const { portraitImgRef, name, companyName, roundedBorder } = this.props

    const altText =
      name && companyName ? `Portrait of ${name} of ${companyName}` : 'Headshot of generic person'

    const borderRadiusDesktop = roundedBorder ? '24px' : '0'
    const borderRadiusMobile = roundedBorder ? '20px' : '0'

    const overFlow = roundedBorder ? 'hidden' : 'visible'

    return (
      <div className="testimonial-mini-card">
        <div className="testimonial-image">
          <Image altText={altText} {...portraitImgRef} />
        </div>
        <TestimonialDetails {...this.props} />
        <style jsx>
          {`
            .testimonial-mini-card {
              display: flex;
              flex-direction: column;
              margin: 0 auto;
            }

            .testimonial-mini-card .testimonial-image {
              display: flex;
              flex: 1 0 100%;
              border-radius: ${borderRadiusDesktop};
              overflow: ${overFlow};
            }

            :global(.testimonial-mini-card picture) {
              width: 100%;
            }

            :global(.testimonial-mini-card picture img) {
              width: 100%;
              object-fit: contain;
            }
            @media (${mq.mobile}) {
              .testimonial-mini-card .testimonial-image {
                border-radius: ${borderRadiusMobile};
              }
            }
          `}
        </style>
      </div>
    )
  }
}
